const HeaderSpacer = () => {
  return <div className="w-full flex h-8" />;
};

export default HeaderSpacer;
